// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";

type Props = $Exact<{
  onDismissHandler: () => void,
  onSubmit: () => void,
  ...PropsFromLocalize,
}>;

export const DeleteAbsenceDocumentModal = (props: Props) => (
  <Modal className="modal-small">
    <ModalHeader toggle={props.onDismissHandler} className="d-flex justify-content-between">
      {props.t("DELETE_DOCUMENT")}
    </ModalHeader>
    <ModalBody className="d-flex justify-content-center align-items-center">
      <p className="normal-font-size">{props.t("DELETE_DOCUMENT_CONFIRMATION")}</p>
    </ModalBody>
    <ModalFooter className="d-flex justify-content-end">
      <Button color="secondary" onClick={props.onDismissHandler}>
        {props.t("CANCEL")}
      </Button>
      <Button materialIcon="delete_forever" onClick={props.onSubmit}>
        {props.t("DELETE")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default localize()(DeleteAbsenceDocumentModal);
